import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';

const DeviceChartWrapper = styled.div`

.ant-radio-button-wrapper-checked {
  color: #FFFFFF !important;
  background-color: #0B2A1B !important;
  border-color: #0B2A1B !important;
}
.ant-radio-button-wrapper:hover {
  color: #0B2A1B !important;
  border-color: #0B2A1B !important;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    background-color: #0B2A1B;
}

`;
export default WithDirection(DeviceChartWrapper);